import { Component, OnInit, OnDestroy, ViewChild, HostListener, Input } from '@angular/core';
import * as Chart from 'chart.js';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PaygService } from '../../../services/payg.service';
import { PaygPaymentTransmissionPerformanceModel } from '../../../models/payg/payg-payment-transmission-performance.model';

@Component({
  selector: 'customers-emergency-credit-chart',
  template: '<canvas id="basechart" #basechart></canvas>',
  styles: [':host { width: 100%; position: relative; display:block; }'],
  host: { 'class': 'block-detail' }
})
export class CustomersEmergencyCreditChartComponent implements OnInit, OnDestroy {

  @ViewChild('basechart', { static: true }) basechart: any;
  @Input() data: PaygPaymentTransmissionPerformanceModel[];
  public paymentTransmissionPerformance: PaygPaymentTransmissionPerformanceModel[] = [];
  chart: any;
  ctx: any;
  public subscriptions: any[] = [];
  debounceTimeout = 2000;
  debounceId: any;
  consumerId: string;
  chartData: any;
  gradientStroke: any;
  pipe: DatePipe = new DatePipe('en_GB');
  clientId: number = 20;
  timePeriod: number = 6;
  siteId: number;

  constructor(private paygService: PaygService, private route: ActivatedRoute) { }

  ngOnInit() {

    this.gradientStroke = this.basechart.nativeElement.getContext('2d').createLinearGradient(500, 0, 100, 0);
    this.gradientStroke.addColorStop(0, '#668ac1');
    this.gradientStroke.addColorStop(1, '#39547f');

    this.subscriptions.push(this.route
      .params
      .subscribe(params => {
        this.consumerId = params['consumerId'];
      }));

    this.subscriptions.push(this.route
      .queryParams
      .subscribe(queryParams => {
        if (+queryParams['timePeriod']) {
          this.timePeriod = +queryParams['timePeriod'];
        }
        if (+queryParams['siteId']) {
          this.siteId = +queryParams['siteId'];
        }

        this.paygService.getPaymentTransmissionPerformance(this.clientId, null, this.timePeriod.toString()).then().then((result) => {
          this.paymentTransmissionPerformance = result;
          this.chartData = this.processData(this.paymentTransmissionPerformance);

          this.createChart();
        });
      }));
  }

  ngOnDestroy() {
    if (this.debounceId) {
      clearTimeout(this.debounceId);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.createChart();
  }

  processData(data: PaygPaymentTransmissionPerformanceModel[]) {

    let graphData = {
      labels: [],
      payments: []
    };

    for (var i = 0; i < data.length; i++) {

      graphData.labels.push(data[i].transmissionTime);
      graphData.payments.push(data[i].payments);
    }

    return (graphData);
  }

  private getChartConfig(): any {
    let config = {
      type: 'line',
      options: {
        legend: {
          display: false
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          backgroundColor: '#ffffff',
          titleFontColor: '#153954',
          bodyFontColor: '#153954',
          borderWidth: 2,
          borderColor: '#009aa3'
        },
        elements: {
          line: {
            tension: 0
          }
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Minutes',
              fontSize: 15,
              fontStyle: "bold",
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Number of Payments',
                fontSize: 15,
                fontStyle: "bold",
              },
              barThickness: 8,
              id: "y-axis-0",
              position: 'left',
              gridLines: {
                display: true
              }
            },
          ]

        }
      }
    }

    return config;
  }

  createChart() {
    if (this.chart != null) this.chart.destroy();
    if (!this.basechart) return;

    let datasets = [] as any;
    let data = [] as any;

    datasets.push({
      fill: 'origin',
      data: this.chartData.payments,
      backgroundColor: '#00539f'
    });

    let config = this.getChartConfig();
    let chartConfiguration: Chart.ChartConfiguration = {
      type: config.type,
      options: config.options,
      data: {
        labels: this.chartData.labels,
        datasets: datasets
      }
    };

    if (this.debounceId) {
      window.clearTimeout(this.debounceId);
    };

    this.debounceId = window.setTimeout(() => {
      if (this.chart != null) this.chart.destroy();
      let ctx = this.basechart.nativeElement;
      this.chart = new Chart(ctx, chartConfiguration);
    }, this.debounceTimeout);
  }

}
